var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.075 24.8205C11.665 25.0598 12.33 25.0598 12.92 24.8205C17.205 23.0772 24 17.0561 24 6.24939C24 5.30203 23.415 4.44746 22.525 4.08609L12.925 0.179464C12.6326 0.0609851 12.3191 0 12.0025 0C11.6859 0 11.3724 0.0609851 11.08 0.179464L1.48 4.08609C0.585 4.44746 0 5.30203 0 6.24939C0 15.9427 5.725 22.6426 11.075 24.8205ZM12 2.34276L21.6 6.24939C21.6 14.7365 16.68 20.7528 12 22.6572C7.125 20.6746 2.4 14.5168 2.4 6.24939L12 2.34276Z","fill":"white"}));
}

Shield.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 25","fill":"none"};

module.exports = Shield;

Shield.default = Shield;
